// Suite Reducer

import { API_STATUS } from '../../../utilities/constants';
import { initializeState } from '../../../utilities/storageUtils';
import suiteActionTypes from './suite.types';

const INITIAL_STATE = {
  selectedSuite: null,
  suiteAvailabilityApiStatus: API_STATUS.IDLE,
  suiteDetailedAvailability: [],
  suiteLcoPackage: {},
  flexTripAllowed: false,
  flexPackage: {},
  dayType: 0,
  personalizationPackageRules: [],
  personalizationResponses: [],
  responseHasPackages: false,
  taxesAndFeesDetailAvailability: {},
  suiteAvailabilityErrorMessage: '',
  isProperty: false,
  isLoggedInAtSuiteSelection: false
};

const suiteReducer = (state, action) => {
  state = initializeState(state, INITIAL_STATE);

  switch (action.type) {
    case suiteActionTypes.SELECT_SUITE:
      return {
        ...state,
        selectedSuite: action.selectedSuite,
        isProperty: action.isProperty,
        isLoggedInAtSuiteSelection: action.isLoggedInAtSuiteSelection ?? false,
        suiteAvailabilityErrorMessage: ''
      };
    case suiteActionTypes.GET_SUITE_DETAILED_AVAILABILITY_INFO:
      return {
        ...state,
        suiteAvailabilityApiStatus: API_STATUS.LOADING
      };
    case suiteActionTypes.GET_SUITE_DETAILED_AVAILABILITY_ERROR:
      return {
        ...state,
        suiteAvailabilityApiStatus: API_STATUS.ERROR,
        suiteAvailabilityErrorMessage: action.suiteAvailabilityErrorMessage,
        suiteDetailedAvailability: []
      };
    case suiteActionTypes.GET_SUITE_DETAILED_AVAILABILITY_SUCCESS:
      return {
        ...state,
        suiteAvailabilityApiStatus: API_STATUS.SUCCEEDED,
        suiteDetailedAvailability: action.suiteDetailedAvailability,
        suiteLcoPackage: action.suiteLcoPackage,
        flexTripAllowed: action.flexTripAllowed ?? false,
        flexPackage: action.flexPackage,
        dayType: action.dayType,
        personalizationPackageRules: action.personalizationPackageRules,
        personalizationResponses: action.personalizationResponses,
        responseHasPackages: action.responseHasPackages,
        selectedSuite: {
          ...state.selectedSuite,
          ...(action.pricingKey && { pricingKey: action.pricingKey }),
          ...(action.rateCode && { rateCode: action.rateCode })
        },
        taxesAndFeesDetailAvailability: action.taxesAndFeesDetailAvailability
      };
    case suiteActionTypes.SET_SUITE_NEW_RATES:
      return {
        ...state,
        suiteDetailedAvailability: action.suiteDetailedAvailability
      };
    case suiteActionTypes.CLEAR_SUITE_SELECTED:
      return {
        ...state,
        selectedSuite: action.selectedSuite ?? null,
        suiteDetailedAvailability: action.suiteDetailedAvailability ?? [],
        isLoggedInAtSuiteSelection: false,
        isProperty: false
      };
    case suiteActionTypes.GET_SUITE_DETAILED_AVAILABILITY_RESET:
      return {
        ...state,
        suiteAvailabilityApiStatus: API_STATUS.IDLE
      };
    case suiteActionTypes.CLEAR_LOGGED_IN_AT_SUITE_SELECTION:
      return { ...state, isLoggedInAtSuiteSelection: false };
    default:
      return state;
  }
};

export default suiteReducer;
